import { render, staticRenderFns } from "./AddSupportUserModal.vue?vue&type=template&id=064838e1&scoped=true&"
import script from "./AddSupportUserModal.vue?vue&type=script&lang=js&"
export * from "./AddSupportUserModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSupportUserModal.vue?vue&type=style&index=0&id=064838e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064838e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064838e1')) {
      api.createRecord('064838e1', component.options)
    } else {
      api.reload('064838e1', component.options)
    }
    module.hot.accept("./AddSupportUserModal.vue?vue&type=template&id=064838e1&scoped=true&", function () {
      api.rerender('064838e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Modals/AddSupportUserModal.vue"
export default component.exports